module.exports = __webpack_public_path__ + "static/media/guest-Generic.51e63c5f.svg";